import { stringify } from 'hub-http/helpers/params';
import { parseLocation } from 'automation-ui-routing/utils';
export const atomicQueryUpdate = (updates = {}, removeProps = [], history, replace = true) => {
  const parsedQuery = parseLocation(history.location);
  const updatedQuery = Object.assign({}, parsedQuery, updates);

  // Always remove this in case there is a malformed
  // search query
  delete updatedQuery[''];
  removeProps.forEach(prop => {
    delete updatedQuery[prop];
  });
  const newLocation = {
    search: stringify(updatedQuery),
    hash: history.location.hash
  };
  if (replace) {
    history.replace(newLocation);
  } else {
    history.push(newLocation);
  }
};